import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@shared/services/analytics';

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, document.referrer).catch(() => {});
  }, [location.pathname]);

  return null;
}
